<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg4 pr-6 pl-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedStartDateFormatted" label="Từ ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.startDate" no-title
                                @input="menuStart = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
                            max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="computedEndDateFormatted" label="Đến ngày" hint="DD-MM-YYYY"
                                    persistent-hint prepend-icon="fa-calendar-alt" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg4 pr-6>
                    <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
                </v-flex>
                <v-flex lg12>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :items="items" :headers="headers" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" show-select item-key="ID" v-model="selectedList">
                        <template v-slot:item="{ item, isSelected, select }">
                        <tr :id="'r-' + item.ID" :active="isSelected">
                                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                                <td>{{ item.ReportDate | display_date('DD-MM-YYYY') }}</td>
                                <td>{{ item.PackageCode }}</td>
                                <td>{{ item.ProductType | display_value(config_producttypes)}}</td>
                                <td class="text-end">{{ item.NumberOfPack | currency }}</td>
                                <td class="text-end">{{ item.Weight | currency('', 1) }}</td>
                                <td class="text-end">{{ item.Volume | currency('', 3) }}</td>
                                <td class="text-end" v-if="adminRole">
                                    <v-edit-dialog :return-value.sync="item.WeightPrice" large lazy persistent @save="saveItem({'ID': item.ID, 'WeightPrice': item.WeightPrice})">
                                        <div>{{ item.WeightPrice | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="Đơn giá KG" :decimal="0" v-model="item.WeightPrice"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end" v-else>{{ item.WeightPrice | currency }}</td>
                                <td class="text-end" v-if="adminRole">
                                    <v-edit-dialog :return-value.sync="item.VolumePrice" large lazy persistent @save="saveItem({'ID': item.ID, 'VolumePrice': item.VolumePrice})">
                                        <div>{{ item.VolumePrice | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="Đơn giá khối" :decimal="0" v-model="item.VolumePrice"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end" v-else>{{ item.VolumePrice | currency }}</td>
                                <td class="text-end" v-if="adminRole">
                                    <v-edit-dialog :return-value.sync="item.OtherFee" large lazy persistent @save="saveItem({'ID': item.ID, 'OtherFee': item.OtherFee})">
                                        <div>{{ item.OtherFee | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="Phí khác" :decimal="0" v-model="item.OtherFee"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end" v-else>{{ item.OtherFee | currency }}</td>
                                <td class="text-end">{{ item.TotalAmount | currency }}</td>
                                <td class="text-end" v-if="adminRole">
                                    <v-edit-dialog :return-value.sync="item.TotalCost" large lazy persistent @save="saveItem({'ID': item.ID, 'TotalCost': item.TotalCost})">
                                        <div>{{ item.TotalCost | currency }}</div>
                                        <template v-slot:input>
                                            <h-currency-input label="Phí thực trả" :decimal="0" v-model="item.TotalCost"></h-currency-input>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                                <td class="text-end">{{ item.TotalDiff | currency }}</td>
                                <td>
                                    <v-edit-dialog :return-value.sync="item.Note" large lazy persistent @save="saveItem({'ID': item.ID, 'Note': item.Note})">
                                        <div>{{ item.Note }}</div>
                                        <template v-slot:input>
                                            <v-text-field label="Ghi chú" v-model="item.Note"></v-text-field>
                                        </template>
                                    </v-edit-dialog>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-if="selectedList.length > 0">
                            <tr class="total-summary-td">
                                <td class="font-weight-bold" colspan="4">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.NumberOfPack | currency }}</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.Weight | currency('', 1) }}</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.Volume | currency('', 3) }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold">{{ selected_summary.OtherFee | currency }}</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.TotalAmount | currency }}</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.TotalCost | currency }}</td>
                                <td class="text-end font-weight-bold">{{ selected_summary.TotalDiff | currency }}</td>
                                <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                        <template v-slot:body.append v-else-if="summary">
                            <tr class="total-summary-td">
                                <td class="font-weight-bold" colspan="4">TỔNG</td>
                                <td class="text-end font-weight-bold">{{ summary.NumberOfPack | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Weight | currency('', 1) }}</td>
                                <td class="text-end font-weight-bold">{{ summary.Volume | currency('', 3) }}</td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold"></td>
                                <td class="text-end font-weight-bold">{{ summary.OtherFee | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalAmount | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalCost | currency }}</td>
                                <td class="text-end font-weight-bold">{{ summary.TotalDiff | currency }}</td>
                                <td class="text-end font-weight-bold"></td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import Filtering from "@/components/Filtering";
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "bao-cao-chi-phi-van-chuyen-tq-vn",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: {...configs.PAGINATION, sortBy: ["ReportDate"], sortDesc: [true]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            selectedList: []
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.reportBigpackage.all.data,
            summary: state => state.reportBigpackage.all.summary,
            total_rows: state => state.reportBigpackage.all.total,
            loading: state => state.reportBigpackage.loading,
            configuration: state => state.configuration.selected,
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        config_producttypes() {
            return this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
        headers() {
            return [
                {
                    text: "Ngày",
                    value: "ReportDate",
                    width: 120,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Mã bao",
                    value: "PackageCode",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Loại hàng",
                    value: "ProductType",
                    filterable: true,
                    values: this.config_producttypes,
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Số kiện",
                    value: "NumberOfPack",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Số KG",
                    value: "Weight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Thể tích",
                    value: "Volume",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đơn giá KG",
                    value: "WeightPrice",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Đơn giá khối",
                    value: "VolumePrice",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí khác",
                    value: "OtherFee",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng phí",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Phí thực trả",
                    value: "TotalCost",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Chênh lệch",
                    value: "TotalDiff",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ghi chú",
                    value: "Note",
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                }
            ]
        },
        selected_summary() {
            var ret = {
                'NumberOfPack': _.sumBy(this.selectedList, 'NumberOfPack'),
                'Weight': _.sumBy(this.selectedList, 'Weight'),
                'Volume': _.sumBy(this.selectedList, 'Volume'),
                'OtherFee': _.sumBy(this.selectedList, 'OtherFee'),
                'TotalAmount': _.sumBy(this.selectedList, 'TotalAmount'),
                'TotalCost': _.sumBy(this.selectedList, 'TotalCost'),
                'TotalDiff': _.sumBy(this.selectedList, 'TotalDiff')
            };
            return ret;
        }
    },
    methods: {
        applyFilter(filterConditions) {
            this.pagination = {
                ...configs.PAGINATION,
                sortBy: this.pagination.sortBy,
                sortDesc: this.pagination.sortDesc
            };
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            param.filter = _.filter(param.filter, p => {return p.column != 'ReportDate'});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT), condition: "d_greater_than_or_equal"});
            param.filter.push({ column: "ReportDate", value: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT), condition: "d_less_than_or_equal"});
            this.$store.dispatch("reportBigpackage/getList", param);
            this.selectedList = [];
        },
        saveItem(item) {
            this.$store.dispatch("reportBigpackage/setDetail", {
                id: item.ID,
                data: item
            });
        }
    },
    mounted() {
        this.$store.dispatch("configuration/getDetail", 1);
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>